/*
=========================================================
* RingOperator Ticker Marquee
=========================================================
*/

import MKBox from "components/MKBox";
import { brandPrimary, brandCream, brandAccent } from "pages/RingOperatorHomepage/theme";

function Ticker() {
  const items = [
    "🌙 Your team gets nights back",
    "📅 Calendar fills while you sleep",
    "✅ No more double-bookings",
    "⚡ Setup in 30 minutes",
    "🌐 Speaks every language",
  ];
  return (
    <MKBox
      component="section"
      className="ro-root"
      sx={{
        overflow: "hidden",
        background: brandPrimary,
        color: brandCream,
        py: 2.25,
        borderTop: "1px solid rgba(14,13,11,0.08)",
        borderBottom: "1px solid rgba(14,13,11,0.08)",
      }}
    >
      <MKBox
        sx={{
          display: "inline-flex",
          whiteSpace: "nowrap",
          animation: "ro-marquee 30s linear infinite",
          fontSize: 15,
          fontWeight: 500,
        }}
      >
        {Array.from({ length: 4 }).flatMap((_, i) =>
          items.map((t, j) => (
            <MKBox
              key={`${i}-${j}`}
              component="span"
              sx={{ px: 3.5, display: "inline-flex", alignItems: "center", gap: 1.5 }}
            >
              <span>{t}</span>
              <MKBox component="span" sx={{ color: brandAccent }}>◇</MKBox>
            </MKBox>
          ))
        )}
      </MKBox>
    </MKBox>
  );
}

export default Ticker;
